import { Stack } from "expo-router";

const APP = "Dash-Hound";

export default function AuthLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: `${APP} — Fast CAT Tracker App for Handlers` }} />
      <Stack.Screen name="login" options={{ title: `Sign In — ${APP}` }} />
      <Stack.Screen name="register" options={{ title: `Sign Up — ${APP}` }} />
      <Stack.Screen name="forgot-password" options={{ title: `Forgot Password — ${APP}` }} />
      <Stack.Screen name="reset-password" options={{ title: `Reset Password — ${APP}` }} />
      <Stack.Screen name="privacy" options={{ title: `Privacy Policy — ${APP}` }} />
      <Stack.Screen name="terms" options={{ title: `Terms of Service — ${APP}` }} />
      <Stack.Screen name="support" options={{ title: `Support — ${APP}` }} />
      <Stack.Screen name="how-to-signup" options={{ title: `How to Sign Up — ${APP}` }} />
    </Stack>
  );
}
